/* eslint-disable */

export function realParaNumber (valor) {
  if (valor) {
    return Number(valor.replace('R$', '')
      .replace('.', '')
      .replace(',', '.'));
  }
  return 0;
}

export function realParaNumberExportacao (valor) {
    if (valor) {
        return valor.replace('.', ',');
    }
    return 0;
}

export function arredondamentoPadrao(valor){
    return ((Math.round(valor*100))/100)
}


export function formatarReal (valor) {
  if (valor) {
    return (Number(valor.replace(',', '.'))
      .toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL'
      }))
  }
  return Number(0)
    .toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL'
    })
}

export function formatarBigDecimal (valor) {
    if (valor) {
        return (Number(valor)
            .toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
            }))
    }
    return Number(0)
        .toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL'
        })
}

export function completarComZerosAEsquerda(value, length) {
    let result = value || '';
    while (result.length < length) {
        result = '0' + result;
    }
    return result;
}

export function formatCPF(value) {
    if (!value) return 'N/A';
    return `${value.slice(0, 3)}.${value.slice(3, 6)}.*`;
}

export function formatTelefone(value) {
    if (!value) return 'N/A';
    return `${value.slice(0, 11)}*`;
}

export function formatPontos(value) {
    if (!value) return '0';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
